const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaCidade: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'TRANSPORTADORA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'TRANSPORTADORA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'TRANSPORTADORA_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.razao_social
                }))
            };

        case 'TRANSPORTADORA_CIDADE_LISTADO':            
			return { ...state, listaCidade: action.payload.data };

        default:
            return state;
    }
}
